<template>
<a href="javascript:void(0)" :class="current" :data-scp="scp" @click.stop="unbind()">
	<i class="icon icon-unbind"></i><span>解绑</span>
</a>
</template>
<script>
import maple from 'maple';
export default {
	props: ['current', 'scp']
	, methods: {
		unbind: function(){
			this.$dispatch('unbind');
		}
	}
}
</script>